module.exports = __webpack_public_path__ + "img/icon_arrow-down-dark.24ab9c76.svg";